import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { Job } from '../models/job.model';
import { Assignment } from '../models/assignment.model';

@Injectable()
export class JobsService {
  private _apiEndpoint = `${environment.apiUrl}`; // URL to web api

  constructor(private http: HttpClient, private _router: Router) {}

  public getJob(job_id) {
    return this.http.get<Job>(`${this._apiEndpoint}jobs/${job_id}/`);
  }

  public publishJob(job_id) {
    return this.http.get<Job>(`${this._apiEndpoint}jobs/${job_id}/publish/`);
  }

  public unpublishJob(job_id) {
    return this.http.get<Job>(`${this._apiEndpoint}jobs/${job_id}/unpublish/`);
  }

  public cloneJob(job_id) {
    return this.http.get<Job>(`${this._apiEndpoint}jobs/${job_id}/clone/`);
  }

  public cloneAsJob(job_id) {
    return this.http.get<Job>(
      `${this._apiEndpoint}jobs/${job_id}/clone-as-job/`
    );
  }

  public deleteJob(job_id) {
    return this.http.delete<Job>(`${this._apiEndpoint}jobs/${job_id}/`);
  }

  public getJobs(
    unit_id,
    is_draft?: boolean,
    is_published?: boolean,
    is_template?: boolean
  ) {
    let queryParams = '';
    if (is_draft !== null && typeof is_draft !== 'undefined') {
      const is_draft_str = '&is_draft=' + (is_draft ? 'True' : 'False'); // Need capital letter for python boolean
      queryParams += is_draft_str;
    }
    if (is_published !== null && typeof is_published !== 'undefined') {
      const is_published_str =
        '&is_published=' + (is_published ? 'True' : 'False');
      queryParams += is_published_str;
    }
    if (is_template !== null && typeof is_template !== 'undefined') {
      const is_template_str =
        '&is_template=' + (is_template ? 'True' : 'False');
      queryParams += is_template_str;
    }
    return this.http.get<Job>(
      `${this._apiEndpoint}units/${unit_id}/jobs/?page_size=500${queryParams}`
    );
  }

  public getJobCategories() {
    return this.http.get(
      `${this._apiEndpoint}suggestions/job-categories/?page_size=50`
    );
  }

  public getJobTitleSuggestions(term: String) {
    return this.http.get(
      `${this._apiEndpoint}suggestions/job-titles/autocomplete/?q=${term}`
    );
  }

  public updateJobAssignment(assignment: Assignment) {
    return this.http.put(
      `${this._apiEndpoint}jobs/${assignment.job_id}/assignments/${assignment.id}/`,
      assignment
    );
  }

  public getJobAssignments(job_id: number) {
    return this.http.get(`${this._apiEndpoint}jobs/${job_id}/assignments/`);
  }

  public updateJob(job) {
    if (job && job.id) {
      return this.http.patch<Job>(`${this._apiEndpoint}jobs/${job.id}/`, job);
    } else {
      return this.http.post<Job>(`${this._apiEndpoint}jobs/`, job);
    }
  }
}
